import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function UseCaseNotReady({
  openPolicyNotReadyDialog,
  setOpenPolicyNotReadyDialog,
}) {
  const handleClose = () => {
    setOpenPolicyNotReadyDialog(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openPolicyNotReadyDialog}
        onClose={handleClose}
        aria-labelledby="Policy not ready"
        aria-describedby="usecase-dialog-description"
      >
        <DialogTitle id="usecase-dialog-title">
          {"Policy is not ready"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="policy-not-ready">
            Policy is not ready for Use Case creation
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
